export default __webpack_public_path__ + "static/media/1333.2a2ca890.jpg";